'use strict';

import incidentLeaderModule from './incident-leader';
import designatedUserModule from './designated-user';
import V2Ctrl from './v2/ctrl.js';
import scheduleDesignationProfileDirective from './v2/schedule-designation-profile';
import reassignDesignationBlockDirective from './v2/reassign-designation-block';
import createEscalationUser from './v2/create-escalation-profile';
import deleteEscalationProfile from './v2/delete-escalation-profile';
import createBeatCallProfile from './v2/create-beat-call-profile';
import appendUserToBeatReserveList from './v2/append-user-to-beat-reserve-list';
import createBeat from './v2/create-beat';
import createBeatPhone from './v2/create-beat-phone';
import createBeatReserveList from './v2/create-beat-reserve-list';
import createEventStakeholder from './v2/create-event-stakeholder';

const MODULE_NAME = 'daupler.entities.admin';

var app = angular.module(MODULE_NAME, [
	incidentLeaderModule,
	designatedUserModule,
]);
app.controller('AdminV2Ctrl', V2Ctrl);
app.directive('scheduleDesignationProfile', scheduleDesignationProfileDirective);
app.directive('reassignDesignationBlock', reassignDesignationBlockDirective);
app.directive('createEscalationUser', createEscalationUser);
app.directive('deleteEscalationProfile', deleteEscalationProfile);
app.directive('createBeatCallProfile', createBeatCallProfile);
app.directive('appendUserToBeatReserveList', appendUserToBeatReserveList);
app.directive('createBeat', createBeat);
app.directive('createBeatPhone', createBeatPhone);
app.directive('createBeatReserveList', createBeatReserveList);
app.directive('createEventStakeholder', createEventStakeholder);

export default MODULE_NAME;
